export class Visit {
    TimeStamp: number;
    Path: string;
}
